var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

(function($, MDB) {
    //Take default from library
    var _unCategorizedText = 'Uncategorized';
    
    $.extend(MDB,
        {   
            iconPicker: function(selector, opts) {
                opts = opts || {};
            
                $.getJSON('/Content/plugins/fonticonpicker/resources/icons.json', function (data) {
                //Either take or assign an uncategorized category
                    data[_unCategorizedText] = data[_unCategorizedText] || [];
                
                    //Merge our unknown items with the uncategorized category
                    Array.prototype.push.apply(
                        data[_unCategorizedText],
                        getUnknownIcons(selector, data)    
                    );
                
                    opts.source = data;
                    opts.hasSearch = opts.hasSearch || false; //Search is on by default
                    opts.theme = 'fip-bootstrap';
                    opts.unCategorizedText = _unCategorizedText;

                    $(selector).fontIconPicker(opts);
                });
            }
        });
    
    function getUnknownIcons(selector, categorizedIcons){
        //Take all non-null values we currently have
        var selectedIcons = $.map(selector, function(opt) {
            return opt.value; 
        })
            .filter(function(v){
                return !!v; 
            });

        //Take all known icons, and flatten them to make them easily searchable
        var knownIcons = Object.keys(categorizedIcons).reduce(function(acc, category){
            //Append all icons from the current category to our accumulated value
            Array.prototype.push.apply(
                acc, 
                categorizedIcons[category]
            );
            
            return acc;
        }, []);
        
        //Return all icons present within our selectedIcons collection
        //but not found in the knownIcons collection
        return _.difference(selectedIcons, knownIcons);
    }

})(jQuery, MDB);